import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { faBullhorn, faFolder, faLaptopMedical, faNewspaper } from '@fortawesome/pro-duotone-svg-icons';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress } from '@mui/material';
import parse from 'html-react-parser';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ModalAction from '../../components/ModalAction';
import ModalFeedBack from '../../components/ModalFeedBack';
import { ComunicadosBenef } from '../../interfaces/entities/ComunicadosBenef';
import { NotificationEnum } from '../../interfaces/enum/NotificationEnum';
import { OpenDetailsType, OpenPageType, SelectedTypeEnum } from '../../interfaces/enum/SelectedTypeEnum';
import { TypeNotificationEnum } from '../../interfaces/enum/TypeNotificationEnum';
import { atualizarIndLidoComunica, excluirComunicado, getComunicadosBenef } from '../../services/ComunicadoService';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import { useNotification } from '../../Store/contexts/NotificationContext';
import './styles.css';
import { defaultNotification } from './defaultStates';


function Notification() {
  const [notification, setNotification] = useState<ComunicadosBenef>(defaultNotification);
  const [loading, setLoading] = useState<boolean>(false);
  const { notificationType, notificationId } = useParams();
  const { updateUnreadNotificationsNumber } = useNotification();
  const navigate = useNavigate();
  const accessibility = useAccessibility();

  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const [modalAction, setModalAction] = useState<null | {
    handleShowModal?: () => void; textOutlinedButton: string; textContainedButton: string;
    title: string; subTitle?: string; handleOutlinedButton?: () => void; handleContainedButton?: () => void;
  }>(null);

  useEffect(() => {
    const getNotification = async () => {
      setLoading(true)
      let notificationsArray = null;
      if (notificationType === TypeNotificationEnum.SaudeOnline || notificationType === TypeNotificationEnum.Notificacoes) {
        notificationsArray = await getSaudeOnlineNotifications();
      } else {
        notificationsArray = await getComunicadosBenef(`${notificationType}`);
      }
      if (notificationsArray !== null) {
        const result = notificationsArray.find((element: ComunicadosBenef) => `${element.idComunic}` === notificationId);

        if (result !== undefined) {
          setNotification(result);
        }

        if (result?.indLido === 'N') {
          await atualizarIndLidoComunica(`${notificationId}`, 'S');

          await updateUnreadNotificationsNumber();
        }

      }
      setLoading(false);
    }

    getNotification();

  }, []);

  const getSaudeOnlineNotifications = async (): Promise<ComunicadosBenef[] | null> => {
    try {
      const notificationsSaudeOnline = await getComunicadosBenef(TypeNotificationEnum.SaudeOnline);
  
      if (notificationsSaudeOnline) {
        return [...notificationsSaudeOnline];
      }
  
      return null;
    } catch (error) {
      console.error('Erro ao buscar notificações de saúde online:', error);
      return null;
    }
  };

  const goBack = () => {
    navigate(-1);
  }

  const handleNotificationAction = () => {
    switch (notification?.openComunic.tipoSelecionado) {
      case SelectedTypeEnum.AbrirAutomatico:
        window.open(notification.openComunic.abrirAutomatico, '_blank');
        break;
      case SelectedTypeEnum.AbrirMeusAgendamentoDetalhe:
        //Tela de detalhes de agendamento não existe, alternativa é redirencionar para tela de meus agendamentos
        navigate('/saudeOnline/meusAgendamentos');
        break;
      case SelectedTypeEnum.AbrirPagina:
        if (notification?.openComunic.abrirPagina === OpenPageType.AtivacaoGuiaFuturaListaPage) {
          navigate('/guiasEautorizacoes/ativacaoDeGuiaFutura')
        }
        if (notification?.openComunic.abrirPagina === OpenPageType.RevalidacaoGuiaListaPage) {
          navigate('/guiasEautorizacoes/revaliacaoDeGuia')
        }
        break;
      case SelectedTypeEnum.AbrirDetalhes:
        if (notification?.openComunic.abrirDetalhes.paginaRedirecionamento === OpenDetailsType.MeuCadastroPage) {
          navigate('/meuPlano/meuCadastro')
        }
        if (notification?.openComunic.abrirDetalhes.paginaRedirecionamento === OpenDetailsType.CadPermissaoDefault) {
          navigate('/meuPlano/permissoesVisualizacao')
        }
        if (notification?.openComunic.abrirPagina === OpenDetailsType.AlterarEnderecoEmailNFEPage) {
          navigate('/meuPlano/meuCadastro')
        }
        if (notification?.openComunic.abrirPagina === OpenDetailsType.CadPermissaoDefault) {
          navigate('/meuPlano/permissoesVisualizacao')
        }
        break;
      default:
        break;
    }
  }

  const deleteNotification = () => {
    setModalAction({
      title: 'Excluir notificação',
      subTitle: 'Tem certeza que deseja excluir notificação?',
      textOutlinedButton: 'Cancelar',
      textContainedButton: 'Excluir',
      handleContainedButton: handleDeleteNotification,
      handleOutlinedButton: handleCloseModalAction,
      handleShowModal: handleCloseModalAction
    })
  }

  const handleDeleteNotification = async () => {
    setModalAction(null);
    await excluirComunicado(`${notificationId}`, 'S').then(() => {
      setModalFeedback({
        icon: 'success',
        title: 'Notificação excluida',
        subTitle: 'Notificação excluída com sucesso!',
        textButton: 'Voltar',
        closeAction: closeModalSuccess,
        buttonAction: closeModalSuccess,
        showButtonModal: true
      });
    });
  }

  const handleCloseModalAction = () => {
    setModalAction(null);
  }

  const closeModalSuccess = () => {
    setModalFeedback(null);
    goBack();
  }

  const getIcon = () => {
    switch (notification?.tipoNotificacao) {
      case NotificationEnum.Mensagem:
        return faBullhorn;
      case NotificationEnum.PesquisaSatisfacao:
        return faNewspaper;
      case NotificationEnum.SaudeOnline:
        return faLaptopMedical;
      default:
        return faFolder;
    }
  }

  return (
    <div className="statement-holder">
      {loading &&
        <div className="loading-holder">
          <CircularProgress />
        </div>
      }
      {!loading &&
        <div className="statement-info-holder">
          <div className="statement-icon-holder">
            <FontAwesomeIcon icon={getIcon()} size='2xl' />
          </div>
          <h1 className='statement-title' style={{color: accessibility.contrastMode ? '#fff' : ''}}>{notification?.openComunic.abrirDetalhes.titulo}</h1>
          <p className='notifications-description' style={{color: accessibility.contrastMode ? '#fff' : ''}}>
            {new Date(notification?.dtIncl || '').toLocaleDateString('pt-BR') + ' ' + new Date(notification?.dtIncl || '').toLocaleTimeString('pt-BR')}
          </p>
          <p className='statement-description' style={{color: accessibility.contrastMode ? '#fff' : ''}}>
              {notification?.openComunic.abrirDetalhes.descricao
                ? parse(notification?.openComunic.abrirDetalhes.descricao)
                : parse(notification.descr)}
          </p>
          <div className="statement-buttons-holder">
            {notification?.openComunic.abrirDetalhes.descricaoBotao !== null &&
              <button className="ticket-button" onClick={handleNotificationAction}>
                {notification.openComunic.abrirDetalhes.descricaoBotao}
              </button>
            }
            <button style={accessibility.buttonStyleAccessibility} className="delete-notification-button" onClick={deleteNotification}>
              <FontAwesomeIcon icon={faTrash} /> &nbsp; Excluir notificação
            </button>
          </div>
          <button className="back-button" onClick={goBack} style={{color: accessibility.contrastMode ? '#fff' : ''}}>
            <FontAwesomeIcon icon={faChevronLeft} style={{color: accessibility.contrastMode ? '#fff' : ''}} />&nbsp;&nbsp;<u>Voltar</u>
          </button>
          <ModalAction
            showModal={!!modalAction}
            handleShowModal={modalAction?.handleShowModal}
            textOutlinedButton={modalAction?.textOutlinedButton || ''}
            textContainedButton={modalAction?.textContainedButton || ''}
            title={modalAction?.title || ''}
            subTitle={modalAction?.subTitle || ''}
            handleOutlinedButton={modalAction?.handleOutlinedButton}
            handleContainedButton={modalAction?.handleContainedButton}
            icon='error'
          />
          <ModalFeedBack
            showModal={!!modalFeedback}
            icon={modalFeedback?.icon as 'success' | 'error'}
            textButton={modalFeedback?.textButton as string}
            title={modalFeedback?.title as string}
            subTitle={modalFeedback?.subTitle as string}
            showButtonModal={modalFeedback?.showButtonModal}
            handleShowModal={modalFeedback?.closeAction}
            handleButtonModal={modalFeedback?.buttonAction}
          />
        </div>
      }
    </div>
  )
}

export default Notification;